import React from 'react';
import {injectIntl} from 'react-intl';
import Alert from 'react-bootstrap/Alert';

import StarterList from '../../components/starter/StarterList';
import API from '../../common/utils/API';

export class RoleList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // Array of role objects
            roles: [],
            // Meta for pagination
            page: 1,
            pageSize: 12,
            pageCount: 2,
            total: 0,
            // Search parameters
            searchTimeout: 0,
            search: '',

            error: false,
        };
    }

    async componentDidMount() {
        await this.fetchRoles();
    }

    fetchRoles = async (pageNumber = 1) => {
        try {
            const result = await API.roles.get(pageNumber, this.state.search);

            this.setState({
                roles: result.items,
                page: result.page,
                pageSize: result.pageSize,
                pageCount: result.pageCount,
                total: result.total,
                error: false,
            });
        } catch (e) {
            this.setState({error: true}, this.clearErrorMessage);
        }
    };

    clearErrorMessage = () => {
        setTimeout(() => {
            if (this.state.error) {
                this.setState({error: false});
            }
        }, 5000);
    };

    handlePageChange = (pageNumber) => {
        return this.fetchRoles(pageNumber);
    };

    handleSearchKeywordChange = (event) => {
        /* istanbul ignore else */
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }
        this.setState({
            search: event.target.value,
            searchTimeout: setTimeout(() => this.fetchRoles(1), 300),
        });
    };

    handleSearchKeywordClear = () => {
        this.setState(
            {
                pageSize: 1,
                search: '',
            },
            () => this.fetchRoles(1),
        );
    };

    render() {
        return (
            <div data-test='roleListComponent'>
                <Alert
                    data-test='errorAlert'
                    variant='danger'
                    className='mb-4'
                    show={this.state.error}
                >
                    <p className='mb-0'>
                        {this.props.intl.formatMessage({
                            id: 'ERROR_PAGES.LOADING_DATA',
                        })}
                    </p>
                </Alert>
                <StarterList
                    onSearchKeywordClear={this.handleSearchKeywordClear}
                    onSearchKeywordChange={this.handleSearchKeywordChange}
                    searchKeyword={this.state.search}
                    onPageChange={this.handlePageChange}
                    page={this.state.page}
                    pageSize={this.state.pageSize}
                    total={this.state.total}
                    data={{
                        headerTitles: [
                            '#',
                            this.props.intl.formatMessage({
                                id: 'ROLES.ROLE_NAME_TABLE_HEADER',
                            }),
                        ],
                        rows: this.state.roles.map((role) => ({
                            content: [role.id, role.name],
                            link: `/roles/${role.id}`,
                        })),
                    }}
                    addNewPermission={'ROLES_CREATE'}
                    addNewLink={`roles/create`}
                />
            </div>
        );
    }
}

export default injectIntl(RoleList);
